//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MtSwitch from "../form/MtSwitch";
import MtRadio from "../form/MtRadio";
import MtInput from "../form/MtInput";
import Button from "../other/Button";
import MtCheckbox from "../form/MtCheckbox";
import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import {checkAllValues, getContentByCode} from '~/utils/utils';
import MtArrowLink from '@/components/other/MtArrowLink'
import Dropdown from '@/components/form/Dropdown'
import DonationModalFull from '~/components/new-blocks/DonationModalFull';
// https://github.com/text-mask/text-mask/tree/master/addons/#createnumbermask - дока по собственным маскам
const numberMask = createNumberMask({
  prefix: '',
  // suffix: ' ₽', // почему то не дает стирать то, что написал, потом разобраться
  thousandsSeparatorSymbol: ' ',
  integerLimit: 8
});

export default {
  components: {
    Dropdown,
    MtSwitch,
    MtRadio,
    MtInput,
    Button,
    MtCheckbox,
    DonationModalFull
  },
  props: {
    stepTwo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showQr: false,
      incognito: false,
      donatPicked: false,
      holidayDonation: false,
      masterpiecePicked: '0',
      policyChecked: false,
      policyError: false,
      offerChecked: false,
      offerError: false,
      formError: null,
      sumButtonSelected: {id: 0, name: '300 ₽', value: 300},
      otherSum: '',
      otherSumMob: '',
      otherSumFocused: false,

      inputValues: {
        name: '',
        surname: '',
        email: '',
        password: '',
      },
      validateValues: {
        name: this.$cookies.get('token') ? true : false,
        surname: this.$cookies.get('token') ? true : false,
        email: this.$cookies.get('token') ? true : false,
        password: this.$cookies.get('token') ? true : false,
      },
      showError: "",
      numberMask: numberMask,
      categories: [],
      hasActiveRecurrent: false,
      hasNotMadeHolidayDonation: true
    }
  },
  computed: {
    sumOptions() {
      if (this.holidayDonation) {
        return[
          {id: 0, name: '500 ₽', value: 500},
          {id: 1, name: '1 000 ₽', value: 1000},
          {id: 2, name: '1 500 ₽', value: 1500},
          {id: 3, name: this.getText('donationForm_otherSumLabel')}
        ]
      }
      return[
        {id: 0, name: '300 ₽', value: 300},
        {id: 1, name: '500 ₽', value: 500},
        {id: 2, name: '1 000 ₽', value: 1000},
        {id: 3, name: this.getText('donationForm_otherSumLabel')}
      ]
    },
    checkValidSum() {
      if (this.sumButtonSelected.id === 3) {
        const errSum = this.getText('donationForm_noSumError');
        const errMinSum = this.getText('donationForm_min100rubError');
        const errMinSumHoliday = errMinSum.replace('100', '500');
        const errMinSumFinal = this.holidayDonation ? errMinSumHoliday : errMinSum;
        const minSum = this.holidayDonation ? 500 : 100;
        return !this.otherSum ? errSum : Number(this.otherSum) < minSum ? errMinSumFinal : false
      }
      return false
    },
    checkAllValues() {
      let result = checkAllValues(this.validateValues, this.incognito);
      if (result && this.sumButtonSelected.id === 3) {
        const minSum = this.holidayDonation ? 500 : 100;
        result = Number(this.otherSum.replace(/ /g, '')) >= minSum
      }
      return result
    },
    showHolidayDonation() {
      if (this.getTextBlocks.data && this.getTextBlocks.data.data) {
        return !!getContentByCode(this.getTextBlocks.data.data, 'donationForm_holidayLabel')
      }
      return false
    }
  },
  watch: {
    showHolidayDonation: {
      immediate: true,
      handler() {
        this.initDonationType()
      }
    },

    hasNotMadeHolidayDonation(val) {
      this.initDonationType()
    },
    otherSumMob: function() {
      this.otherSum = this.otherSumMob
    },
    donatPicked (val) {
      if(val) {
        this.incognito = false
        this.holidayDonation = false
      }
    },
    holidayDonation (val) {
      if(val) {
        // здесь null потому что при false radio кнопка отображается активной
        this.donatPicked = null
        this.incognito = false
      }
      this.sumButtonSelected = this.sumOptions[0]
      this.otherSum = ''
      this.otherSumMob = ''
    }
  },
  mounted() {
    if (this.$cookies.get('token')) {
      this.checkHolidayDonation()

      this.$axios({
        method: 'get',
        url: `/api/v1/personnel/get/?lang=${this.$i18n.locale || 'ru'}&extraParams=recurrentInfo`,
      })
      .then(({data}) => {
        if(data.data.recurrentInfo) {
          this.hasActiveRecurrent = data.data.recurrentInfo.hasActiveRecurrent
        }
        this.inputValues.name = data.data.name;
        this.inputValues.surname = data.data.surname
      })
      .catch(err => {
        console.log('ошибка при загрузке данных', err)
      })
    }
  },
  methods: {
    getText(code) {
      if (this.getTextBlocks && this.getTextBlocks.data) {
        return getContentByCode(this.getTextBlocks.data.data, code);
      }
      return '';
    },
    isAvailableToOpen() {
      if (this.checkAvailableToOpen && this.checkAvailableToOpen.data) {
        return this.checkAvailableToOpen.data.data;
      }
      return false;
    },
    pictureUrl (url) {
      return this.$absoluteImageUrl(url)
    },
    validateForm() {
      const { name, surname, email, password } = this.inputValues;

      if (!this.stepTwo) {
        this.policyError = false;
        this.offerError = false;
        this.formError = null;

        if ((!this.policyChecked && !this.$cookies.get('token')) || !this.offerChecked) {
          this.policyError = !this.policyChecked;
          this.offerError = !this.offerChecked;
          return
        }

        if (!this.checkAllValues) {
          this.formError = this.getText('donationForm_fillAllFieldsError');
          return
        }

        if (this.$cookies.get('token')) {
          let url = ""

          if(this.donatPicked) {
            url = "&extraParams=recurrentInfo"
          }
          this.$axios({method: 'get',url: `/api/v1/personnel/get/?lang=${this.$i18n.locale || 'ru'}${url}`})
            .then(({data}) => {
              if(data.data.recurrentInfo && data.data.recurrentInfo.hasActiveRecurrent) {
                this.showError = data.data.recurrentInfo.alert
              } else {
                this.inputValues.email = data.data.email;
                if (this.holidayDonation) {
                  this.processPayment()
                } else {
                  this.getStepTwo()
                }
              }
            })
        } else {
          this.authorizationAttempt()
        }
      } else {
        this.processPayment()
      }
    },
    getStepTwo() {
      this.$emit('step', true);
      this.$axios({
        method: 'get',
        url: `/api/v1/gallery/getItemCategories/?lang=${this.$i18n.locale || 'ru'}`
      })
        .then(({data}) => {
          const priorityCategories = [];
          const sortedCategories = data.data.filter(obj => {
            if (obj.availableToOpenItems && obj.picture) {
              switch(obj.code) {
                case 'zhivopis':
                case 'skulptura':
                case 'grafika':
                  priorityCategories.push(obj);
                  return false;
                  break;
                default:
                  return true;
                  break;
              }
            }
            return false
          });
          const lacks = 3 - priorityCategories.length;
          if (lacks) {
            this.categories = sortedCategories.length <= lacks ? [...priorityCategories, ...sortedCategories] : [...priorityCategories, ...sortedCategories.slice(0, lacks)]
          } else {
            this.categories = priorityCategories
          }
        })
        .catch(err => {
          console.log('ERORRRR', err)
        })
    },
    processPayment() {
      const { name, surname, email, password } = this.inputValues;
      let text = `lang=${this.$i18n.locale || 'ru'}&recurrent=${this.donatPicked}&anonymous=${this.incognito}&email=${email}&holiday=${this.holidayDonation}`;

      let currSumYm

      if (!this.incognito) {
        text += `&name=${name}&surname=${surname}`
      }
      if (this.sumButtonSelected.id === 3) {
        text += `&sum=${this.otherSum.replace(/ /g, '')}`
        currSumYm = this.otherSum.replace(/ /g, '')
      } else {
        text += `&sum=${this.sumButtonSelected.value}`
        currSumYm = this.sumButtonSelected.value
      }
      if (this.masterpiecePicked !== '0') {
        text += `&masterpieceCategoryId=${this.masterpiecePicked}`
      }

      window.ym(69320587,'reachGoal', `${this.masterpiecePicked}`, {order_price: currSumYm, currency: 'RUB'})

      this.$axios({
        method: 'post',
        url: '/api/v1/donate/add/',
        data: text
      })
        .then(({data}) => {
          if (data.error) {
            this.formError = data.error.message;
            this.$emit('step', false)
          } else {
            window.location.href = data.data.gpbPaymentUrl
          }
        })
        .catch(err => {
          console.log('ошибка при запросе на донат', err)
        })
    },
    checkHolidayDonation() {
      this.$axios({
        method: 'get',
        url: `/api/v1/user/isHaveHolidayDonate/`
      })
        .then(({data}) => {
          this.hasNotMadeHolidayDonation = !data.data.hasHolidayDonate
        })
        .catch(err => {
          console.log('ERORRRR', err)
        })
    },
    authorizationAttempt() {
      const { name, surname, email, password } = this.inputValues;
      this.$axios({
        method: 'post',
        url: '/api/auth/',
        data: `lang=${this.$i18n.locale || 'ru'}&email=${email}&password=${password}&holidayDonate=${this.holidayDonation ? 'Y' : 'N'}`
      })
        .then(({data}) => {
          if (!data.error) {
            this.$cookies.set('token', data.data.token);
            this.$axios.setHeader('Authorization-token', `REST:${data.data.token}`);
            this.$store.commit('changeNeedUpdatePhoto', true);
            if (this.holidayDonation) {
              this.processPayment()
            } else {
              this.validateForm()
            }
          } else {
            if(data.error.code && data.error.code === 'HAVE_HOLIDAY_DONATE') {
              const message = data.error.message;
              this.formError = message
              return
            }

            this.$axios({
              method: 'post',
              url: '/api/register/',
              data: `lang=${this.$i18n.locale || 'ru'}&email=${email}&password=${password}&name=${name ? name[0].toUpperCase() + name.slice(1) : ''}&surname=${surname ? surname[0].toUpperCase() + surname.slice(1) : ''}`
            })
              .then(({data}) => {
                if (data.error) {
                  let message = data.error.message;
                  const passwordError = 'Неверный пароль';
                  message = /Пользователь с логином/.test(message) ? passwordError : message;
                  this.formError = message
                } else {
                  this.$cookies.set('token', data.data.token);
                  this.$axios.setHeader('Authorization-token', `REST:${data.data.token}`);
                  if (this.holidayDonation) {
                    this.processPayment()
                  } else {
                    this.getStepTwo()
                  }
                }
              })
              .catch(err => {
                console.log('ERORRRR', err)
              })
          }
        })
        .catch(err => {
          console.log('ERORRRR', err);
          const errText = this.getText('donationForm_serverError');
          this.formError = errText
        })
    },
    initDonationType() {
      const canUseHoliday =
        this.showHolidayDonation && this.hasNotMadeHolidayDonation

      if (canUseHoliday) {
        this.holidayDonation = true
        this.donatPicked = null
      } else {
        this.holidayDonation = false
        this.donatPicked = false
      }
    },
  },
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'block-8',
        auto: true,
        params: {
          code: ['block8knopka',
            'donationForm_anonymousInputValue',
            'donationForm_anonymousLabel',
            'donationForm_categoryDescription',
            'donationForm_customSum',
            'donationForm_buttonText',
            'donationForm_error',
            'donationForm_fillAllFieldsError',
            'donationForm_luckyText',
            'donationForm_min100rubError',
            'donationForm_nameInputLabel',
            'donationForm_noSumError',
            'donationForm_offerLabel',
            'donationForm_otherSumLabel',
            'donationForm_passwordInputLabel',
            'donationForm_policyLabel',
            'donationForm_policyLabelContinue',
            'donationForm_recurrentDescription',
            'donationForm_recurrentLabel',
            'donationForm_recurrentLabelMobile',
            'donationForm_requiredMessage',
            'donationForm_singleDescription',
            'donationForm_singleDescriptionNoHiddenMasterpieces',
            'donationForm_singleLabel',
            'donationForm_singleLabelMobile',
            'donationForm_holidayLabel',
            'donationForm_holidayLabelMobile',
            'donationForm_holidayDescription',
            'donationForm_serverError',
            'donationForm_surnameInputLabel',
            'donationForm_sum',
          ],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    checkAvailableToOpen () {
      return {
        url: `/api/v1/gallery/checkAvailableToOpen`,
        key: `checkAvailableToOpen`,
      }
    },
    getPopupWeb () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'get-popup-web',
        auto: true,
        params: {
          code: ['pop-up-web'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getPopupMob () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'get-popup-mob',
        auto: true,
        params: {
          code: ['pop-up-mob'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
    getQr () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'get-popup-data',
        auto: true,
        params: {
          code: ['qr-popup'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    },
  }
}
